<template>
    <div class="component component__system_uploader_image">
        <input
            ref="uploader"
            class="component__system_uploader_image_input"
            type="file"
            :accept="formats"
            :multiple="multiple"
            :name="name | toKebabCase"
            :id="`system-uploader-image-input-${name}`"
            @change="setFiles"
        >
    </div>
</template>

<script>
export default {
  name: 'component-system-uploader-image',
  data () {
    return {
      files: [],
      definedFiles: []
    }
  },
  props: {
    formats: {
      type: String,
      default: '.jpg, .png, .jpeg'
    },
    multiple: {
      type: Boolean,
      default: true
    },
    name: {
      type: String,
      default: 'system-uploader'
    },
    uploadDispatchName: {
      type: String,
      default: 'storageFilesUpload'
    }
  },
  methods: {
    openFileUploader () {
      const isNewSecondStageToken = this.$store.getters.getAuthUserIsSecondStageTokenNewLMS
      const secondStageTokenHasCustomerId = this.$store.getters.getAuthUserSecondStageTokenDataCustomerId
      if (isNewSecondStageToken && !secondStageTokenHasCustomerId) {
        this.$store.dispatch('defaultNotificationToastsAdd', {
          title: 'Media upload',
          message: `You have to select workspace before uploading any media.`,
          status: 'error'
        })
      } else {
        this.$refs.uploader.click()
      }
    },
    setFiles: function () {
      this.files = this.$refs.uploader.files
      this.definedFiles = []

      const fileDataStructure = this.$store.getters.getStorageFileDataStructure
      let formData = new FormData()

      for (let i = 0; i < this.files.length; i++) {
        let predefinedFile = JSON.parse(JSON.stringify(fileDataStructure))
        predefinedFile.title = this.files[i].name
        predefinedFile.loading = true

        this.definedFiles.push(predefinedFile)
      }

      for (let i = 0; i < this.files.length; i++) {
        let file = this.files[i]
        formData.append(`files[${i}]`, file)
      }

      this.performUploadFiles(formData)
    },
    performUploadFiles (data) {
      this.emitUpload('', this.definedFiles)
      this.$store.dispatch(this.uploadDispatchName, data).then(response => {
        this.emitUpload('success', response.data)
      }).catch(() => {
        this.emitUpload('error', this.definedFiles)
      })
    },
    emitUpload (type, data) {
      // type must be one of: ['success', 'error'] or undefined
      data = data || this.files
      this.$emit(`emit-upload${type ? `-${type}` : ''}`, data)
      this.$refs.uploader.value = ''
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/shared/componentsystemuploaderimage";
</style>
